export default {
  // list
  'base_port.query.name': 'name',
  'base_port.query.name.placeholder': 'Enter name',
  'base_port.column.name': 'name',
  'base_port.column.createTime': 'createTime',
  'base_port.column.updateTime': 'updateTime',
  // edit
  'base_port.edit.title': 'Edit BasePort',
  'base_port.add.title': 'Add BasePort',
  'base_port.edit.success': 'Edit Successful',
  'base_port.add.success': 'Add Successful',
  'base_port.form.name.required': 'name cannot be null',
  'base_port.form.name': 'name',
  'base_port.form.name.placeholder': 'Enter name',
}
